<template>
  <ChipsField
    id="mealplan-multiple-terminal-id"
    name="config.terminal_id"
    :label="translate(`${LOCALE_PREFIX}.form.multipleTerminalId`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.multipleTerminalIdPlaceholder`)"
    :addOnBlur="true"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
